import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgUtil } from './ag-util';

/** Defines how to build a routerLink from the ag-grid row data.  The url and params returned by routeDataFn will be
 *  combined to make a routerLink url, e.g. apps/timereview/details;monthId=5;userId=1007;jobId=1005
 */
export interface IGroupLinkRendererParams extends ICellRendererParams {
  /** router link onto which params are added */
  url: string;

  /** Function that returns route params from a grid row data object.
   * @param data entity/vm data for the grid row
   * @param isGroup whether the row is a group row
   * @param field field name being rendered.  Gives the leaf field group rows.
   * @param level Group level if grouping.  0 = top level.
   */
  routeDataFn: (data: any, isGroup: boolean, field?: string, level?: number) => { [key: string]: string | number };
}

/** Render cell data as links, using different url parameters for group and non-group rows */
@Component({
  selector: 'ag-group-link-renderer',
  template: `<span *ngIf="routerLink"
      ><a class="bluelink" [routerLink]="routerLink" [queryParams]="queryParams">{{ cellValue }}</a> </span
    ><span *ngIf="!routerLink">{{ cellValue }}</span>`,
})
export class GroupLinkRendererComponent implements AgRendererComponent {
  cellValue: string;
  queryParams: { [key: string]: string | number };
  routerLink: string;
  pname: string;

  // gets called once for each cell before the renderer is used
  agInit(params: IGroupLinkRendererParams): void {
    this.cellValue = params.valueFormatted ? params.valueFormatted : params.value;

    let routeData = {};
    const isGroup = params.node.group;
    const data = AgUtil.getRowData(params);
    if (params.routeDataFn) {
      routeData = params.routeDataFn(data, isGroup, params.colDef.field, params.node.level);
    }
    if (routeData) {
      this.routerLink = params.url;
      this.queryParams = routeData;
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}
